module.exports = __webpack_public_path__ + "img/ser.b860b9aa.png";